<template>
  <v-container fluid pa-0 grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h2 class="headline">Users</h2>
            <v-spacer />
            <v-text-field
              v-model="search"
              label="Search"
              :hint="hintText ? hintText : ''"
              single-line
              :color="appButtonColor"
              @keyup.enter="searchTerm"
              :mask="ssnSearch ? searchMask : ''"
              ref="search"
            >
              <template v-slot:append>
                <v-switch
                  :color="appButtonColor"
                  hide-details
                  class="mr-3"
                  v-model="ssnSearch"
                  label="SSN"
                ></v-switch>
                <v-icon @click="searchTerm">search</v-icon>
              </template>
            </v-text-field>
          </v-card-title>
          <v-data-table
            :headers="dashboardHeaders"
            :items="searchAccounts"
            :rows-per-page-items="[15]"
            class="elevation-1 table-striped my-3"
            :pagination.sync="pagination"
            :loading="searchLoading ? appButtonColor : searchLoading"
            :no-data-text="loadingText"
          >
            <template slot="items" slot-scope="props">
              <tr class="row" @click="getItem(props.item)">
                <td>{{ props.item.prefUsername ? props.item.prefUsername : props.item.username }}</td>
                <td>{{ props.item.alerus360id ? props.item.alerus360id : props.item.sponsor }}</td>
                <td>{{ props.item.enabled ? "Active" : "Inactive" }}</td>
                <td>{{ props.item.firstName }}</td>
                <td>{{ props.item.lastName }}</td>
                <td>{{ props.item.email }}</td>
                <td v-if="!mersBranded">{{ hideSSN(props.item.ssn) }}</td>
                <td :class="orphaned(props.item).error ? 'out-of-sync' : ''" v-if="userGroup === 'SystemAdmin'">{{ orphaned(props.item).text }}</td>
                <td class="remove" v-if="userGroup === 'SystemAdmin' || userGroup === 'DeleteUsers' || userGroup === 'Super'">
                  <v-icon v-if="grabUserDetails(props.item)" color="red" @click.stop="deleteUser(props.item)">cancel</v-icon>
                  <v-icon v-else></v-icon>
                </td>
              </tr>
            </template>
          </v-data-table>
          <confirm ref="confirm"></confirm>
        </v-card>
      </v-flex>
      <vue-snotify></vue-snotify>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Confirm from "@/components/Confirm.vue";
export default {
  name: "dashboard",
  components: {
    Confirm
  },
  data() {
    return {
      ssnSearch: true,
      searchEntered: false,
      searchLoading: false,
      maskState: false,
      searchMask: "###-##-####",
      rules: {
        search: v => {
          if (!v.length) {
            return false;
          } else if (v.length < 3 && !this.ssnSearch) {
            return "Please enter at least 3 characters";
          } else if (v.length < 9 && this.ssnSearch) {
            return "Please enter full SSN";
          }
        }
      },
      search: "",
      pagination: {
        descending: false,
        sortBy: "username"
      },
      headers: [
        { text: "Username", sortable: true, value: "username" },
        { text: "A360", sortable: true, value: "" },
        { text: "Account", sortable: true, value: "enabled" },
        { text: "First Name", sortable: true, value: "firstName" },
        { text: "Last Name", sortable: true, value: "lastName" },
        {
          text: "Email",
          sortable: true,
          value: "email",
          width: "5"
        },
        { text: "SSN", sortable: false, value: "ssn" }
      ],
      mersHeaders: [
        { text: "Username", sortable: true, value: "username" },
        { text: "A360", sortable: true, value: "" },
        { text: "Account", sortable: true, value: "enabled" },
        { text: "First Name", sortable: true, value: "firstName" },
        { text: "Last Name", sortable: true, value: "lastName" },
        {
          text: "Email",
          sortable: true,
          value: "email",
          width: "5"
        }
      ]
    };
  },
  async created() {},
  watch: {
    ssnSearch(val) {
      this.$refs.search.setCaretPosition(this.search.length + 2);
      if (val && this.search.length > 9) this.search = this.search.slice(0, 9);
    }
  },
  computed: {
    ...mapState("user", ["mersBranded", "user"]),
    ...mapGetters("user", ["userGroup"]),
    ...mapState("accounts", ["searchAccounts"]),
    appButtonColor() {
      return this.mersBranded ? "#33715A" : "#0B2A4A";
    },
    dashboardHeaders() {
      let headers = JSON.parse(JSON.stringify(this.headers))
      if (this.mersBranded) headers = this.mersHeaders
      if (this.userGroup === "SystemAdmin") {
        headers.push({ 
          text: "MyProfile Username", 
          value: "profileUsername" 
        })
        headers.push({
          text: "Delete User",
          value: "",
          width: "5%"
        })
      }
      return headers
    },
    hintText() {
      return this.rules.search(this.search);
    },
    loadingText() {
      if (!this.searchEntered) {
        return "Please enter search";
      } else if (this.searchEntered && this.searchLoading) {
        return "Searching for results...";
      } else if (this.searchEntered) {
        return "No results found";
      }
    }
  },
  methods: {
    orphaned(val) {
      let res = {
        error: false,
        orphaned: true
      }
      if (!val.profileUsername) {
        res.text = "NA"
      }
      else if (val.username !== val.profileUsername) {
        res.text = val.profileUsername
        res.error = true
      } 
      else {
        res.text = val.profileUsername
        res.orphaned = false
      } 
      return res
    },
    grabUserDetails(val) {
      let user = {
        username: val.username
      }
      if(val.alerus360id) {
        user.a360id = val.alerus360id
      }
      else if (val.sponsor) {
        user.a360id = val.sponsor
      }
      else return false
      return user
    },
    async deleteUser(user) {
      if (await this.$refs.confirm.open('Delete User', 'Are you sure?', { color: 'red' })) {
        let userData = this.grabUserDetails(user)
        if (!userData) return
        userData.actionBy = this.user.username
        userData.orphaned = this.orphaned(user).orphaned
        let res = await this.$store.dispatch("accounts/removeUser", userData);
        if (res) {
          this.displayNotification("success", "User Deleted");
        } else {
          this.displayNotification("error", "Error Deleting User");
        }
      }
    },
    displayNotification(type, notification) {
      if (type === "success") {
        this.$snotify[type](`${notification}`);
      } else {
        this.$snotify[type](`${notification}`, "", {
          timeout: 0,
        });
      }
    },
    async searchTerm() {
      if (this.ssnSearch && this.search.length === 9) {
        this.searchEntered = true;
        this.searchLoading = true;
        await this.$store.dispatch("accounts/searchUserAccounts", {
          term: this.search,
          ssn: true
        });
        this.searchLoading = false;
      } else if (!this.ssnSearch && this.search.length > 2) {
        this.searchEntered = true;
        this.searchLoading = true;
        await this.$store.dispatch("accounts/searchUserAccounts", {
          term: this.search,
          ssn: false
        });
        this.searchLoading = false;
      }
    },
    hideSSN(ssn) {
      if (ssn) {
        return `XXX-XX-${ssn.slice(-4)}`;
      } else return "";
    },
    getItem(item) {
      this.$router.push({
        name: "user",
        params: {
          id: item.username
        }
      });
    }
  },
  beforeDestroy() {
    this.$store.commit("accounts/emptySearchAccounts");
  },
};
</script>

<style lang="scss" scoped>
.v-list__tile__title {
  font-size: 1.05rem;
}
.no-scroll {
  overflow: hidden;
}
span {
  color: red;
  padding-top: 0.5rem;
  display: inline-block;
}
h3 {
  font-weight: initial;
}
.theme--light .v-list__tile__sub-title {
  color: #40a7c7;
}
.row {
  cursor: pointer;
}
// .v-card__title {
//   padding-bottom: 0;
// }
.mers h2.headline {
  font-family: "Ubuntu" !important;
}
.v-input--switch {
  margin: 0;
  padding: 0;
}
</style>

<style lang="scss">
  .remove {
    text-align: center;
  }
  .out-of-sync {
    color: #d11717;
  }
</style>
